import api from '@/api/campaigns'
import { findIndex } from 'lodash'
import store from '@/store'

const namespaced = true

const state = {
  campaigns: null
}

// getters
const getters = {
  list: state => {
    return state.campaigns
  }
}

// actions
const actions = {
  refresh({ commit }) {
    api.listCampaigns(store.state.route.params.company, store.state.route.params.month,
      campaigns => {
        commit('setCampaigns', campaigns)
      })
  },
  set({ commit }, payload) {
    commit('setCampaigns', payload);
  },
  add({ commit }, payload) {
    commit('addCampaign', payload);
  },
  update({ commit }, payload) {
    commit('updateCampaign', payload);
  },
  remove({ commit }, payload) {
    commit('removeCampaign', payload);
  },
  addAsset({ commit }, payload) {
    commit('addAsset', payload);
  },
  updateAsset({ commit }, payload) {
    commit('updateAsset', payload);
  },
  removeAsset({ commit }, payload) {
    commit('removeAsset', payload);
  },
  addFile({ commit }, payload) {
    commit('addFile', payload);
  },
  updateFile({ commit }, payload) {
    commit('updateFile', payload);
  },
  removeFile({ commit }, payload) {
    commit('removeFile', payload);
  },
}

// mutations
const mutations = {
  setCampaigns(state, payload) {
    state.campaigns = payload;
  },
  addCampaign(state, payload) {
    state.campaigns = [...state.campaigns, payload]
  },
  updateCampaign(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.slug });
    state.campaigns.splice(campaign, 1, payload);
  },
  removeCampaign(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.slug });
    state.campaigns.splice(campaign, 1);
  },
  addAsset(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.campaign });
    let collection = findIndex(state.campaigns[campaign].collections, { type: payload.collection });
    if (collection === -1) {
      collection = (state.campaigns[campaign].collections.push({
        assets: [],
        type: payload.collection,
      })) - 1;
    }
    state.campaigns[campaign].collections[collection].assets = [...state.campaigns[campaign].collections[collection].assets, payload.data]
  },
  updateAsset(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.campaign });
    let collection = findIndex(state.campaigns[campaign].collections, { type: payload.collection });
    let asset = findIndex(state.campaigns[campaign].collections[collection].assets, { slug: payload.data.slug });
    state.campaigns[campaign].collections[collection].assets.splice(asset, 1, payload.data);
  },
  removeAsset(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.campaign });
    let collection = findIndex(state.campaigns[campaign].collections, { type: payload.collection });
    let asset = findIndex(state.campaigns[campaign].collections[collection].assets, { slug: payload.data });
    state.campaigns[campaign].collections[collection].assets.splice(asset, 1);
    if (state.campaigns[campaign].collections[collection].assets.length === 0) {
      state.campaigns[campaign].collections.splice(collection, 1);
    }
  },
  addFile(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.campaign });
    let collection = findIndex(state.campaigns[campaign].collections, { type: payload.collection });
    let asset = findIndex(state.campaigns[campaign].collections[collection].assets, { slug: payload.asset });
    state.campaigns[campaign].collections[collection].assets[asset].files = [...state.campaigns[campaign].collections[collection].assets[asset].files, payload.data]
  },
  updateFile(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.campaign });
    let collection = findIndex(state.campaigns[campaign].collections, { type: payload.collection });
    let asset = findIndex(state.campaigns[campaign].collections[collection].assets, { slug: payload.asset });
    let file = findIndex(state.campaigns[campaign].collections[collection].assets[asset].files, { id: payload.data.id });
    state.campaigns[campaign].collections[collection].assets[asset].files.splice(file, 1, payload.data);
  },
  removeFile(state, payload) {
    let campaign = findIndex(state.campaigns, { slug: payload.campaign });
    let collection = findIndex(state.campaigns[campaign].collections, { type: payload.collection });
    let asset = findIndex(state.campaigns[campaign].collections[collection].assets, { slug: payload.asset });
    let file = findIndex(state.campaigns[campaign].collections[collection].assets[asset].files, { id: payload.data });
    state.campaigns[campaign].collections[collection].assets[asset].files.splice(file, 1);
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
